import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { getTagsDisponibles } from '../apis/dispositivosApi';

interface SentinelTag {
  sentinelId: string;
  displayName: string;
  friendlyName: string;
  sentinelType: string;
  timeOfAssignment: string;
}

export const useTagsDisponibles = () => {
  const { token } = useContext(AuthContext);

  const {
    data: tagsDisponibles = [],
    isLoading,
    error,
    refetch
  } = useQuery<SentinelTag[], Error>({
    queryKey: ['tags-disponibles'],
    queryFn: () => getTagsDisponibles(token!),
    enabled: !!token,
    staleTime: 2 * 60 * 1000, // 2 minutos (más frecuente para OnAsset)
    gcTime: 5 * 60 * 1000, // 5 minutos
  });

  return {
    tagsDisponibles: tagsDisponibles as SentinelTag[],
    isLoading,
    error,
    refetch
  };
};
